module.exports = __webpack_public_path__ + "media/images/chat_icon_pikawakasan-68fdd3adf27d2f122504d1304c9e9b82.png";